import React from "react";
import { cn } from "../../../Utils/helper";

export function FormSelect({
  icon,
  options,
  value,
  onChange,
  rightIcon,
  name,
  classNameText,
}) {
  return (
    <div className="flex gap-1.5 items-center px-1.5 py-2.5  w-full leading-none whitespace-nowrap bg-white rounded-xl border border-solid border-stone-200 min-h-[50px]">
      {icon && (
        <img
          loading="lazy"
          src={icon}
          alt=""
          className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
        />
      )}
      {/* <select
        value={value}
        onChange={onChange}
        className="flex-1 shrink self-stretch my-auto min-w-60 bg-transparent border-none outline-none"
      > */}
      <select
        name={name}
        value={value?.value || ""}
        onChange={(e) => {
          const selectedOption = options.find(
            (option) => option.value === e.target.value
          );
          onChange(selectedOption);
        }}
        className={cn(
          "flex-1 shrink self-stretch my-auto min-w-60 bg-transparent border-none outline-none text-[#A0A0A0] text-base",
          classNameText
        )}
      >
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {rightIcon && (
        <img
          loading="lazy"
          src={rightIcon}
          alt=""
          className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
        />
      )}
    </div>
  );
}
